<div class="docs-view">
  @switch (viewType()) {

  @case ('to-process') {
  <app-to-process />
  }

  @case ('processed') {
  <app-processed />
  }

  @case ('error') {
  <app-in-error />
  }

  @default {
  <app-to-process />
  }
  }
</div>